/*
==========================================================
V-HYDRA HERO
==========================================================
*/

document.addEventListener('DOMContentLoaded', () => {

    const hero = document.querySelector('.vhydra-hero');

    if (!hero) return;

    const video = hero.querySelector('.vhydra-hero__video');

    /*
    ==========================================================
    HERO ENTRANCE
    ==========================================================
    */

    requestAnimationFrame(() => {

        hero.classList.add('vhydra-hero--loaded');

    });

    /*
    ==========================================================
    VIDEO
    ==========================================================
    */

    
        /*
    ==========================================================
    SMOOTH SCROLL
    ==========================================================
    */

    const smoothLinks = hero.querySelectorAll('a[href^="#"]');

    smoothLinks.forEach((link) => {

        link.addEventListener('click', (event) => {

            const targetId = link.getAttribute('href');

            if (!targetId || targetId === '#') return;

            const target = document.querySelector(targetId);

            if (!target) return;

            event.preventDefault();

            target.scrollIntoView({

                behavior: 'smooth',
                block: 'start'

            });

        });

        });

    /*
    ==========================================================
    RESIZE
    ==========================================================
    */


    /*
    ==========================================================
    SCROLL INDICATOR
    ==========================================================
    */

    const scrollIndicator = hero.querySelector('.vhydra-hero__scroll');

    if (scrollIndicator) {

        scrollIndicator.addEventListener('click', () => {

            const nextSection = hero.nextElementSibling;

            if (!nextSection) return;

            nextSection.scrollIntoView({

                behavior: 'smooth',
                block: 'start'

            });

        });

    }
        /*
    ==========================================================
    FUTURE MODULES
    ==========================================================

    Este espaço fica reservado para as próximas etapas:

    • Hero Reveal on Scroll
    • Mouse Parallax
    • Slow Zoom
    • CTA Micro Interactions
    • Dynamic Overlay
    • Header Transparency
    • Performance Optimizations

    ==========================================================
    */

});